import { render } from "./AcademicView.vue?vue&type=template&id=698d2b4a"
import script from "./AcademicView.vue?vue&type=script&lang=js"
export * from "./AcademicView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__